const INITIAL_WIDTH: number = 600;
const INITIAL_HEIGHT: number = 500;

const windowConfig = {
  MINIMAL_HEIGHT: 34,
  MINIMAL_WIDTH: 126,
  PIXELS_TO_LEAVE: 20,
  INITIAL_WIDTH: INITIAL_WIDTH,
  INITIAL_HEIGHT: INITIAL_HEIGHT
};

export default windowConfig;
